
import {
  IconQuality,
  RevButton,
  RevDivider,
  RevRating,
} from '@backmarket/design-system'

import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { fetchReviewsSummaryByProduct } from '@http/endpoints'
import { TRACKING_ZONE } from '@internal-reviews/components/Page/constants'
import RateFilter from '@internal-reviews/components/RateFilter'
import ReviewsLegalModal from '@internal-reviews/components/ReviewsLegalModal'
import UserComment from '@internal-reviews/components/UserComment'
import logger from '@logger'
import { trackClick, trackReviewBlockImpression } from '@tracking/events'

import translations from './ReviewsBlock.translations'

export default {
  components: {
    IconQuality,
    RateFilter,
    RevRating,
    RevButton,
    RevDivider,
    UserComment,
    ReviewsLegalModal,
  },
  props: {
    averageRate: {
      type: Number,
      required: true,
    },
    reviewsCount: {
      type: Number,
      required: true,
    },
    reviews: {
      type: Array,
      default: () => [],
    },
    link: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    trackingInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rateDistribution: [],
    }
  },
  computed: {
    translations: () => translations,
    shouldDisplayCta() {
      return this.reviewsCount > 1
    },
    reviewTrackingInfo() {
      return {
        ...this.trackingInfo,
        averageRate: this.averageRate,
        pageType: this.$route.name,
      }
    },
  },

  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },

  async mounted() {
    this.watchReviewInViewport()

    const [{ payload: rateDistribution }] = await Promise.all([
      await this.$store
        .dispatch('http/request', {
          request: fetchReviewsSummaryByProduct,
          pathParams: { productId: this.productId },
          // [COM-362] TODO to remove withReviewTranslation when it is done on BE side
          queryParams: { withReviewTranslation: true },
        })
        .catch((error) => {
          logger.error(error)

          return { payload: {} }
        }),
    ])

    this.rateDistribution = rateDistribution.statsInfo || []
  },
  methods: {
    watchReviewInViewport() {
      this.unobserve = createObserver(this.$el, () => {
        trackReviewBlockImpression(this.reviewTrackingInfo)
      })
    },
    displayDivider(index) {
      return index < this.reviews.length - 1
    },
    trackReviews() {
      trackClick({
        zone: TRACKING_ZONE,
        name: 'see_all_reviews',
        pageType: this.$route.name,
      })
    },
  },
}
